import { pickBy, includes, compose, values } from "ramda";

export const pickByProduct = pickBy((_, k) => includes("product", k));
export const pickProductValues = compose(values, pickByProduct);
